import * as React from "react";

function SvgQrIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="#6F7E95" width="16" height="16" viewBox="0 0 19 19">
            <path d="M26 42V38H30V42ZM22 38V28H26V38ZM38 32V24H42V32ZM34 24V20H38V24ZM10 28V24H14V28ZM6 24V20H10V24ZM24 10V6H28V10ZM8.5 15.5H15.5V8.5H8.5ZM6 18V6H18V18ZM8.5 39.5H15.5V32.5H8.5ZM6 42V30H18V42ZM32.5 15.5H39.5V8.5H32.5ZM30 18V6H42V18ZM34 42V36H30V32H38V38H42V42ZM26 28V24H34V28ZM18 28V24H14V20H26V24H22V28ZM20 18V10H24V14H28V18ZM10.5 13.5V10.5H13.5V13.5ZM10.5 37.5V34.5H13.5V37.5ZM34.5 13.5V10.5H37.5V13.5Z" />
        </svg>

    )
}
export default SvgQrIcon;


// WEBPACK FOOTER //
// ./src/iconComponents/qrcode.js